// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"style_buttonWrapper__2RzwP","loginButton":"style_loginButton__1EVbQ"};